<div class="runs-tab">
  @if (runs.isLoading()) {
    <p class="regular-14">{{ 'loading' | transloco }}</p>
  } @else if (!sortedRuns().length) {
    <p class="regular-14">{{ 'noResultsFound' | transloco }}</p>
  } @else {
    <div class="display-flex vertical gap-12">
      @for (run of sortedRuns(); track run.id) {
        <div class="run-card">
          <div class="run-header display-flex gap-12">
            <span class="semibold-14">#{{ run.id }} · {{ run.date | date }} · {{ run.kind }} · {{ run.rarity }} · <span [class]="statusClass(run)">{{ run.status }}</span></span>
            @if (run.status === 'review') {
              <button type="button" class="secondary-bar-btn" (click)="openToVote(run)">{{ 'cardsAdminToVote' | transloco }}</button>
            }
            @if (canResume(run)) {
              <button type="button" class="secondary-bar-btn" (click)="resume(run)">{{ 'cardsAdminGenerateMissing' | transloco }}</button>
            }
          </div>
          @if (run.themeHint) {
            <div class="regular-14 color-soft-grey margin-bottom-12">{{ run.themeHint }}</div>
          }

          <div class="candidates-row display-flex gap-12">
            @for (candidate of run.candidates; track candidate.id) {
              <div class="candidate-card display-flex vertical gap-12">
                <img [src]="candidate.thumbUrl" width="120" [alt]="candidate.name.en" />
                <div class="semibold-14">{{ candidate.name.en }} / {{ candidate.name.uk }}</div>
                <div class="regular-14">{{ candidate.votesCount }}</div>
                @if (candidate.isWinner) {
                  <div class="semibold-14 color-green">&#10003;</div>
                }
                @if (run.status === 'review') {
                  <button type="button" class="primary-bar-btn" (click)="openPublish(run, candidate)">{{ 'cardsAdminPublish' | transloco }}</button>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  }

  @if (showPublishModal()) {
    <app-modal
      [title]="'cardsAdminPublish' | transloco"
      [footerButtons]="publishModalButtons"
      (closeEvent)="closePublish()">
      @if (selectedCandidate(); as candidate) {
        <p class="regular-14">{{ candidate.name.en }} / {{ candidate.name.uk }}</p>
        <p class="regular-14 color-red">{{ 'cardsAdminPublishWarning' | transloco }}</p>
      }
    </app-modal>
  }

  @if (showVoteModal()) {
    <app-modal
      [title]="'cardsAdminToVote' | transloco"
      [footerButtons]="voteModalButtons"
      (closeEvent)="closeToVote()">
      <input type="date" class="datetime-input" [formControl]="voteDate" />
      <p class="regular-14 color-soft-grey margin-top-12">{{ 'cardsAdminVoteDateHint' | transloco }}</p>
    </app-modal>
  }
</div>
